import { AudioDevice } from './AudioDevice';
import { AudioDeviceWebAudioApi } from './AudioDeviceWebAudioApi';
import { Compatibility } from '../helpers/compatibility';
import { IResumeGamePopupComponent } from '../components/popups/resume-game-popup.component';

export class AudioSystem {
  public readonly audioDevice: AudioDevice;
  private _lastVolume: number | null = null;

  constructor(audioDevice: AudioDevice) {
    this.audioDevice = audioDevice;
  }

  public pause(): void {
    this._lastVolume = this.audioDevice.globalVolume;
    this.audioDevice.globalVolume = 0;
  }

  public async resume(resumeGamePopup?: IResumeGamePopupComponent): Promise<void> {
    if (this._lastVolume === null) {
      return;
    }

    this.audioDevice.globalVolume = this._lastVolume;
    this._lastVolume = null;

    if (
      resumeGamePopup &&
      this.audioDevice instanceof AudioDeviceWebAudioApi &&
      Compatibility.IsMobileBrowser
    ) {
      const context = this.audioDevice.context;
      const state = context.state;
      if (state === 'suspended' || (state as string) === 'interrupted') {
        await resumeGamePopup.show();
        await context.resume();
      }
    }
  }
}
